<template>
<div class="chapter">
<div class="inner_page">
      ﻿

	
		<title>Collection of Sand: Essays</title>
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="EB04MainHead" id="page_v">Contents</h2>
<p class="EB15ContentsText" id="col0000019">
<a href="#/xhtml/translator">
<em>Translator’s Introduction</em>
</a>
</p>
<p class="EB15ContentsText" id="col0000020">
<a href="#/xhtml/authorspresentation">
<em>The Author’s Presentation of the Volume</em>
</a>
</p>
<p class="EB15ContentsText" id="col0000021">
<a href="#/xhtml/noteontext">
<em>A Note on the Text</em>
</a><br/><br/>
</p>
<p class="EB15ContentsText" id="col0000022">
<a href="#/xhtml/part001">
<span class="small">COLLECTION OF SAND</span>
</a><br/><br/>
</p>
<p class="EB15ContentsText" id="col0000023">
<a href="#/xhtml/part001">
<span class="small">I EXHIBITIONS—EXPLORATIONS</span>
</a>
</p>
<p class="EB15ContentsTextIndent" id="col0000024">
<a href="#/xhtml/chapter001">
<em>Collection of Sand</em>
</a>
</p>
<p class="EB15ContentsTextIndent" id="col0000025">
<a href="#/xhtml/chapter002">
<em>How New the New World Was</em>
</a>
</p>
<p class="EB15ContentsTextIndent" id="col0000026">
<span href="#/xhtml/chapter003" title="Link target outside of Sample">
<em>The Traveller in the Map</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000027">
<span href="#/xhtml/chapter004" title="Link target outside of Sample">
<em>The Museum of Wax Monsters</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000028">
<span href="#/xhtml/chapter005" title="Link target outside of Sample">
<em>The Dragon Tradition</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000029">
<span href="#/xhtml/chapter006" title="Link target outside of Sample">
<em>Before the Alphabet</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000030">
<span href="#/xhtml/chapter007" title="Link target outside of Sample">
<em>The Wonders of the Popular Press</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000031">
<span href="#/xhtml/chapter008" title="Link target outside of Sample">
<em>A Novel Inside a Painting</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000032">
<span href="#/xhtml/chapter009" title="Link target outside of Sample">
<em>Say It with Knots</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000033">
<span href="#/xhtml/chapter010" title="Link target outside of Sample">
<em>Writers Who Draw</em>
</span><br/><br/>
</p>
<p class="EB15ContentsText" id="col0000034">
<span href="#/xhtml/part002" title="Link target outside of Sample">
<span class="small">II THE EYE’S RAY</span>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000035">
<span href="#/xhtml/chapter011" title="Link target outside of Sample">
<em>In Memory of Roland Barthes</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000036">
<span href="#/xhtml/chapter012" title="Link target outside of Sample">
<em>Day-flies in the Fortress</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000037">
<span href="#/xhtml/chapter013" title="Link target outside of Sample">
<em>The Pig and the Archaeologist</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000038">
<span href="#/xhtml/chapter014" title="Link target outside of Sample">
<em>The Narrative of Trajan’s Column</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000039">
<span href="#/xhtml/chapter015" title="Link target outside of Sample">
<em>The Written City: Inscriptions and Graffiti</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000040">
<span href="#/xhtml/chapter016" title="Link target outside of Sample">
<em>Thinking the City: The Measure of Spaces</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000041">
<span href="#/xhtml/chapter017" title="Link target outside of Sample">
<em>The Redemption of Objects</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000042">
<span href="#/xhtml/chapter018" title="Link target outside of Sample">
<em>Light in Our Eyes</em>
</span><br/><br/>
</p>
<p class="EB15ContentsText" id="page_vi">
<span href="#/xhtml/part003" title="Link target outside of Sample">
<span class="small">III ACCOUNTS OF THE FANTASTIC</span>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000043">
<span href="#/xhtml/chapter019" title="Link target outside of Sample">
<em>The Adventures of Three Clockmakers and Three Automata</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000044">
<span href="#/xhtml/chapter020" title="Link target outside of Sample">
<em>Fairy Geography</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000045">
<span href="#/xhtml/chapter021" title="Link target outside of Sample">
<em>The Archipelago of Imaginary Places</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000046">
<span href="#/xhtml/chapter022" title="Link target outside of Sample">
<em>Stamps from States of Mind</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000047">
<span href="#/xhtml/chapter023" title="Link target outside of Sample">
<em>The Encyclopedia of a Visionary</em>
</span><br/><br/>
</p>
<p class="EB15ContentsText" id="col0000048">
<span href="#/xhtml/part004" title="Link target outside of Sample">
<span class="small">IV THE SHAPE OF TIME</span>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000049">
<span href="#/xhtml/chapter024" title="Link target outside of Sample">
<em>Japan:</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000050">
			    <span href="#/xhtml/chapter025" title="Link target outside of Sample"><em>The Old Woman in the Purple
					Kimono</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000051">
			    <span href="#/xhtml/chapter026" title="Link target outside of Sample"><em>The Obverse of the
				Sublime</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000052">
			    <span href="#/xhtml/chapter027" title="Link target outside of Sample"><em>The Wooden Temple</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000053">
			    <span href="#/xhtml/chapter028" title="Link target outside of Sample"><em>The Thousand Gardens</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000054">
			    <span href="#/xhtml/chapter029" title="Link target outside of Sample"><em>The Moon Chasing the
				Moon</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000055">
			    <span href="#/xhtml/chapter030" title="Link target outside of Sample"><em>The Sword and the Leaves</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000056">
			    <span href="#/xhtml/chapter031" title="Link target outside of Sample"><em>The Pinballs of Solitude</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000057">
			    <span href="#/xhtml/chapter032" title="Link target outside of Sample"><em>Eros and Discontinuity</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000058">
			    <span href="#/xhtml/chapter033" title="Link target outside of Sample"><em>The Ninety-Ninth Tree</em></span><br/><br/>
</p>
<p class="EB15ContentsTextIndent" id="col0000059">
<span href="#/xhtml/chapter034" title="Link target outside of Sample">
<em>Mexico:</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000060">
			    <span href="#/xhtml/chapter035" title="Link target outside of Sample"><em>The Shape of the Tree</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000061">
			    <span href="#/xhtml/chapter036" title="Link target outside of Sample"><em>Time and Branches</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000062">
			    <span href="#/xhtml/chapter037" title="Link target outside of Sample"><em>The Forest and the Gods</em></span><br/><br/>
</p>
<p class="EB15ContentsTextIndent" id="col0000063">
<span href="#/xhtml/chapter038" title="Link target outside of Sample">
<em>Iran:</em>
</span>
</p>
<p class="EB15ContentsTextIndent" id="col0000064">
			    <span href="#/xhtml/chapter039" title="Link target outside of Sample"><em>The Mihrab</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000065">
			    <span href="#/xhtml/chapter040" title="Link target outside of Sample"><em>The Flames within the
				Flames</em></span>
</p>
<p class="EB15ContentsTextIndent" id="col0000066">
			    <span href="#/xhtml/chapter041" title="Link target outside of Sample"><em>The Sculptures and the
					Nomads</em></span><br/><br/>
</p>
<p class="EB15ContentsTextIndent">
<span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><em>About the Author</em></span>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7e3b3cce